module.exports = __webpack_public_path__ + "img/L_7S.21bc2369.png";